import React from 'react';
import { Reveal } from './Reveal';
const resultados = [{
  emoji: '🎨',
  title: 'Diseñar desde cero',
  desc: 'Crear decoraciones únicas y personalizadas para cada evento'
}, {
  emoji: '💼',
  title: 'Emprender con confianza',
  desc: 'Saber cuánto cobrar, cómo presupuestar y conseguir clientes'
}, {
  emoji: '🎪',
  title: 'Armar estructuras profesionales',
  desc: 'Arcos, columnas, guirnaldas y centros de mesa con globos'
}, {
  emoji: '📱',
  title: 'Mostrar tu trabajo',
  desc: 'Fotografiar y publicar tus creaciones para atraer clientes'
}, {
  emoji: '💰',
  title: 'Generar ingresos reales',
  desc: 'Convertir tu habilidad en un emprendimiento rentable'
}];
export function Transformacion() {
  return <section className="w-full bg-white py-24" data-id="element-167" data-mp="9sz570f8unya">
      <div className="mx-auto max-w-5xl px-6" data-id="element-168" data-mp="9tr16ccr6np3">
        <Reveal data-id="element-169" data-mp="4tuxke7ywya2">
          <h2 className="font-display text-center text-3xl font-semibold text-[#2f2a33] sm:text-4xl" data-id="element-170" data-mp="4ued5oa5bakx">
            Al terminar este curso vas a poder...
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-171" data-mp="82rj7he84pma">
          {resultados.map((r, i) => <Reveal key={i} delay={i * 0.06} data-id="element-172" data-mp="c44p1rhbgst7" data-mpi={i}>
              <div className="flex h-full flex-col rounded-2xl border border-[#a78bdb]/20 bg-[#faf7fe] p-7" data-id="element-173" data-mp="c3beeff8lj5s">
                <span className="text-4xl" data-id="element-174" data-mp="h1mqyxwx27rp">{r.emoji}</span>
                <h3 className="mt-4 text-lg font-semibold text-[#2f2a33]" data-id="element-175" data-mp="m1r9ethdxckk">
                  {r.title}
                </h3>
                <p className="mt-2 text-[#2f2a33]/70" data-id="element-176" data-mp="r0c5qhtinc3q">{r.desc}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}